import state from './state'
import mutations from './mutations'
import getters from './getters'
import actions from './actions'

/** @type {import('vuex').Module} */
export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
